/*
 * @Author: your name
 * @Date: 2021-11-03 17:08:17
 * @LastEditTime: 2023-10-20 13:38:37
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: 三方售后订单
 * @FilePath: \newBj-admin\src\api\orderApi\audit.js
 */
import { generate } from '@/utils/request';

const config = {
  prefix: '/third-adapter/v1/{organizationId}',
  items: [
    { key: 'csgOrderSync', url: '/third-order/csgOrderSync', method: 'POST' },
    // 创建第三方售后单头
    {
      key: 'addThirdRefundOrder',
      url: '/third-party-after-sale-headers/create-thirdParty-refund',
      method: 'POST',
      loadingMore: 0,
    },
    // 创建重发单
    {
      key: 'addInternalResendOrder',
      url: '/third-order/resend-order',
      method: 'POST',
      loadingMore: 0,
    },
    // 创建补发单
    {
      key: 'addInternalReissueOrder',
      url: '/third-order/replacement-order',
      method: 'POST',
      loadingMore: 0,
    },
    // 删除外部订单
    {
      key: 'deleteThirdOrder',
      url: '/third-order/delete-order',
      method: 'POST',
      loadingMore: 0,
    },

    // 第三方售后单头列表
    {
      key: 'getThirdRefundOrder',
      url: '/third-party-after-sale-headers/order-page',
      method: 'POST',
      loadingMore: 0,
    },
    // 第三方售后单明细-退货/退款
    {
      key: 'detailThirdRefundOrder',
      url: '/third-party-after-sale-headers/{id}',
      method: 'GET',
      loadingMore: 0,
    },

    // 第三方售后单明细-退货/退款
    {
      key: 'detailThirdRefundOrder',
      url: '/third-party-after-sale-headers/order-base-detail-by-id-code',
      method: 'POST',
      loadingMore: 0,
    },
    // 查询可退货商品-创建退货单内部调用
    {
      key: 'getThirdOrderCanReturnGoods',
      url: '/third-party-after-sale-headers/can-return-goods',
      method: 'GET',
    },
    // 三方单修改SKU POST /v1/{organizationId}/third-order/modifyThirdItem
    {
      key: 'editThirdOrderGoods',
      url: '/third-order/modifyThirdItem',
      method: 'POST',
    },
    {
      key: 'getDashboardKeyData',
      url: '/dashboard/keyData',
      method: 'POST',
      loadingHide: true,
    },
    // 追踪物流详情 ===》 翟建豪 post /v1/{organizationId}/post/track/query
    { key: 'getTrackingDetails', url: '/post/track/query', method: 'POST' },
    {
      key: 'getDashboardMain',
      url: '/dashboard/main',
      method: 'POST',
      loadingHide: true,
    },
    // 运动计算器列表
    {
      key: 'detailsCustomerList',
      url: '/details/customerList',
      method: 'POST',
    },
    // new  列表
    {
      key: 'detailsLists',
      url: '/details/detailsList',
      method: 'POST',
    },
    //  上传
    {
      key: 'detailsaveDetails',
      url: '/details/saveDetails',
      method: 'POST',
    },
    // 修改
    {
      key: 'detailsEdit',
      url: '/details/edit',
      method: 'POST',
    },
     //  导出
     {
      key: 'detailsExports',
      url: '/details/export',
      method: 'POST',
      rType: 2,
    },
    // 详情页
    {
      key: 'LogisticsList',
      url: '/details/logisticsList',
      method: 'POST',
    },
        //  实时计算
    {
      key: 'ealTimeComputing',
      url: '/details/realTimeComputing',
      method: 'POST',
      rType: 2,
    },
  ],
};

export default {
  ...generate(config),
};
